'use client'

import { Loader2 } from 'lucide-react'
import { useLogoutFlow } from '@/lib/commerce/hooks'
import { authTitle } from './authStyles'

export default function Logout() {
  useLogoutFlow()
  return (
    <div role="status">
      <Loader2 aria-hidden className="size-6 animate-spin text-muted-foreground" strokeWidth={1.25} />
      <h1 className={`mt-6 ${authTitle}`}>Гарж байна</h1>
      <p className="mt-3 text-sm text-muted-foreground">Таныг системээс гаргаж байна. Түр хүлээнэ үү…</p>
    </div>
  )
}
